import { createFileRoute } from '@tanstack/react-router';
import { AdminEditSheet } from '@/pages/admins/edit-sheet';

export const Route = createFileRoute('/admin/_layout/admins/_layout/edit/$id')({
  component: AdminEditRoute,
});

function AdminEditRoute() {
  const { id } = Route.useParams();

  return <AdminEditSheet id={id} />;
}
